var map = {
	"./home.js": [
		"./assets/resources/js/pages/home.js",
		"assets_resources_js_pages_home_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./assets/resources/js/pages lazy recursive ^\\.\\/.*\\.js$ referencedExports: default, default";
module.exports = webpackAsyncContext;